//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function disableCompanyService (id) {
  try {
    await api.patch(`/empresas/${id}/inativar`);
    toast.success("Empresa inativada com sucesso!");
    return true;
  } catch (error) {
    toast.error("Erro ao inativar empresa!");
    return false;
  }
}